export const SOURCE_LABELS = {
  owner: "Team owner",
  default: "Role default",
  role_override: "Role override",
  person_override: "Person override",
  role: "Not available for this role",
  package: "Staffing is not in your plan",
};

const namesFor = (ids, options) =>
  (ids || [])
    .map((id) => options.find((option) => option.value === id)?.label)
    .filter(Boolean);

export const describeScope = (
  { staff_department_ids: departmentIds, staff_position_ids: positionIds },
  departments,
  positions,
) => {
  if (!departmentIds && !positionIds) return "Every department";
  return [
    ...namesFor(departmentIds, departments),
    ...namesFor(positionIds, positions),
  ].join(", ");
};

export const roleGrantFor = (grants, roleId, permissionKey) =>
  grants.find(
    (grant) =>
      grant.grantee_type === "Role" &&
      grant.grantee_id === roleId &&
      grant.permission === permissionKey,
  );
